module.exports = __webpack_public_path__ + "static/media/doubleShieldRound.34deb2f4.jpg";